import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import ComponentTable from '../../../Components/Table/Index';
import { Column } from '../../../Components/Table/Types';
import * as Icon from '@mui/icons-material/';
import { useNavigate } from 'react-router-dom';
import { PapelAtualizar, PapelCadastrar } from '../../../../routes/RoutesNames';
import PapelController from '../../../../controllers/PapelController';
import { toast } from 'react-toastify';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { Button } from '../../../../shared/components/button/Button';
import { ButtonMenu } from '../../../../shared/components/ButtonMenu';
import FormBuilder from '../../../../shared/components/FormBuilder';

interface Row {
  RoleId: number;
  Nome: string;
  telas: number;
  usuarios: number;
  protegido: string;
}

export default function PapelPesquisar() {
  const navigate = useNavigate();

  const tableColumns: Column[] = [
    { id: 'Id', label: 'Código', minWidth: 0, maxWidth: 80, align: 'center' },
    { id: 'Nome', label: 'Papel', minWidth: 0, maxWidth: 200 },
    { id: 'Telas', label: 'Telas', minWidth: 0, maxWidth: 80, align: 'center' },
    { id: 'Usuarios', label: 'Usuários', minWidth: 0, maxWidth: 80, align: 'center' },
    { id: 'BtnMenu', label: '', width: 60, minWidth: 0, maxWidth: 60, align: 'right' },
  ];

  const fields = [
    { name: 'Nome', label: 'Papel', type: 'text', col: 3 },
    { type: 'submit', icon: <Icon.Search style={{ fontSize: '28px' }} />, col: 1 },
  ];

  const initialValues = { Nome: '' };
  const [tableRows, setTableRows] = useState<any[]>([]);

  const handleEditItem = (roleId: number) => {
    navigate(PapelAtualizar.replace(':id', roleId.toString()));
  };

  const handleDeleteItem = async (item: Row) => {
    const response = await PapelController.Excluir(item.RoleId);

    if (response.StatusCode === 204) {
      toast('Papel excluído.', { type: 'success' });
      handleSubmit(initialValues);
      return;
    }

    // A procedure explica a recusa em português - "há usuários ativos com este papel",
    // "o papel Administrador não pode ser excluído". Mostrar o texto dela, e não um
    // genérico, é o que diz à pessoa o que fazer a seguir.
    toast(response?.Data ?? 'Não foi possível excluir o papel.', {
      type: 'error',
      autoClose: 10000,
    });
  };

  const handleSubmit = async (values: any) => {
    const response = await PapelController.Listar(values?.Nome ?? '');

    if (response.StatusCode !== 200 || !Array.isArray(response.Data)) {
      setTableRows([]);
      if (response.StatusCode !== 204) {
        toast(response?.Data ?? 'Não foi possível listar os papéis.', { type: 'error' });
      }
      return;
    }

    setTableRows(
      response.Data.map((item: Row) => ({
        Id: item.RoleId,
        Nome: item.Nome,
        Telas: item.telas,
        Usuarios: item.usuarios,
        BtnMenu: (
          <ButtonMenu
            items={[
              { onClick: () => handleEditItem(item.RoleId), menu: 'Editar' },
              {
                onClick: () => handleDeleteItem(item),
                menu: 'Excluir',
                // O Administrador não é excluível, e o item apagado diz isso antes do
                // clique - melhor do que deixar tentar e recusar depois.
                disabled: item.protegido === 'S',
                confirmar: `Excluir o papel "${item.Nome}"? Quem o tiver perde as telas dele.`,
              },
            ]}
          />
        ),
      }))
    );
  };

  useEffect(() => {
    handleSubmit(initialValues);
  }, []);

  return (
    <Box>
      <HeaderComponent
        text={'Papéis de acesso'}
        ButtonRight={
          <Button
            className={''}
            variant='success'
            onClick={() => navigate(PapelCadastrar)}
            iconStart={<Icon.Add />}
            title={'Incluir'}
          />
        }
      />
      <FormBuilder
        fields={fields}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        gap='gap-3'
      />
      <ComponentTable
        columns={tableColumns}
        rows={tableRows}
        onRowDoubleClick={(row) => handleEditItem(row.Id)}
      />
    </Box>
  );
}
